export const onboardingConstants = {
  CHANGE_PROFIL: '@onboarding/CHANGE_PROFIL',
  CHANGE_STEP: '@onboarding/CHANGE_STEP',
  CHANGE_DATA_TRADER: '@onboarding/CHANGE_DATA_TRADER',
  CHANGE_SHOW_DIALOG: '@onboarding/SHOW_DIALOG',
};
